module.exports = __webpack_public_path__ + "static/img/pattern-logo.d97ec32d.png";